"use client"

import Image from "next/image"
import React from "react"

import ScrollingLogos from "@/ui/patterns/ScrollingLogos"

import PageGrid from "../../PageGrid"

const sesssionsLTR = [
  {
    name: "Tokenization",
    image: (
      <div className="block w-12 h-12 lg:h-16 lg:w-16 md:h-14 md:w-14">
        <Image
          width={248}
          height={248}
          sizes="(min-width: 248px) 248px, 100vw"
          src="/swell/topics/topic-tokenization.png"
          alt="Tokenization Icon"
          className="w-full h-auto lg:h-16 lg:w-16 md:h-14 md:w-14 object-contain"
        />
      </div>
    ),
  },
  {
    name: "Industry Trends",
    image: (
      <div className="block w-12 h-12 lg:h-16 lg:w-16 md:h-14 md:w-14">
        <Image
          width={248}
          height={248}
          sizes="(min-width: 248px) 248px, 100vw"
          src="/swell/topics/topic-industry.png"
          alt="Industry Trends Icon"
          className="w-full h-auto lg:h-16 lg:w-16 md:h-14 md:w-14 object-contain"
        />
      </div>
    ),
  },
  {
    name: "Crypto in Financial Services",
    image: (
      <div className="block w-12 h-12 lg:h-16 lg:w-16 md:h-14 md:w-14">
        <Image
          width={248}
          height={248}
          sizes="(min-width: 248px) 248px, 100vw"
          src="/swell/topics/topic-services.png"
          alt="Crypto in Financial Services Icon"
          className="w-full h-auto lg:h-16 lg:w-16 md:h-14 md:w-14 object-contain"
        />
      </div>
    ),
  },
  {
    name: "Payments",
    image: (
      <div className="block w-12 h-12 lg:h-16 lg:w-16 md:h-14 md:w-14">
        <Image
          width={248}
          height={248}
          sizes="(min-width: 248px) 248px, 100vw"
          src="/swell/topics/topic-payments.png"
          alt="Payments Icon"
          className="w-12 h-12 lg:h-16 lg:w-16 md:h-14 md:w-14 object-contain"
        />
      </div>
    ),
  },
  {
    name: "Regional Regulatory Progress",
    image: (
      <div className="block w-12 h-12 lg:h-16 lg:w-16 md:h-14 md:w-14">
        <Image
          width={248}
          height={248}
          sizes="(min-width: 248px) 248px, 100vw"
          src="/swell/topics/topic-regulation.png"
          alt="Regional Regulatory Progress Icon"
          className="w-full h-auto lg:h-16 lg:w-16 md:h-14 md:w-14 object-contain"
        />
      </div>
    ),
  },
  {
    name: "Technology Innovation / AI",
    image: (
      <div className="block w-12 h-12 lg:h-16 lg:w-16 md:h-14 md:w-14">
        <Image
          width={248}
          height={248}
          sizes="(min-width: 248px) 248px, 100vw"
          src="/swell/topics/topic-innovation.png"
          alt="Technology Icon"
          className="w-full h-auto lg:h-16 lg:w-16 md:h-14 md:w-14 object-contain"
        />
      </div>
    ),
  },
  {
    name: "Stablecoins",
    image: (
      <div className="block w-12 h-12 lg:h-16 lg:w-16 md:h-14 md:w-14">
        <Image
          width={248}
          height={248}
          sizes="(min-width: 248px) 248px, 100vw"
          src="/swell/topics/topic-stablecoins.png"
          alt="Stablecoins Icon"
          className="w-full h-auto lg:h-16 lg:w-16 md:h-14 md:w-14 object-contain"
        />
      </div>
    ),
  },
  {
    name: "Security & Compliance",
    image: (
      <div className="block w-12 h-12 lg:h-16 lg:w-16 md:h-14 md:w-14">
        <Image
          width={248}
          height={248}
          sizes="(min-width: 248px) 248px, 100vw"
          src="/swell/topics/topic-security.png"
          alt="Security Icon"
          className="w-full h-auto lg:h-16 lg:w-16 md:h-14 md:w-14 object-contain"
        />
      </div>
    ),
  },
  {
    name: "Custody",
    image: (
      <div className="block w-12 h-12 lg:h-16 lg:w-16 md:h-14 md:w-14">
        <Image
          width={248}
          height={248}
          sizes="(min-width: 248px) 248px, 100vw"
          src="/swell/topics/topic-custody.png"
          alt="Custody Icon"
          className="w-full h-auto lg:h-16 lg:w-16 md:h-14 md:w-14 object-contain"
        />
      </div>
    ),
  },
  {
    name: "Financial Inclusion",
    image: (
      <div className="block w-12 h-12 lg:h-16 lg:w-16 md:h-14 md:w-14">
        <Image
          width={248}
          height={248}
          sizes="(min-width: 248px) 248px, 100vw"
          src="/swell/topics/topic-inclusion.png"
          alt="Financial Inclusion Icon"
          className="w-full h-auto lg:h-16 lg:w-16 md:h-14 md:w-14 object-contain"
        />
      </div>
    ),
  },
]

const sessionsArrLTR = sesssionsLTR.map((session) => (
  <div key={session.name} className="flex items-center mx-6">
    {session.image}
    <span className="ml-8 text-newblue-90 lg:headline4 md:headline5 heading2">
      {session.name}
    </span>
  </div>
))

const SessionTopics: React.FC = () => (
  <section className="text-gray-90 py-8 md:pt-20 md:pb-24 bg-gray-2.5">
    <PageGrid>
      <div className="flex flex-col items-center lg:col-start-4 lg:col-span-6 col-span-full">
        <h4 className="mb-8 text-center lg:mb-12 heading1 md:headline4">
          Session Topics
        </h4>
        <p className="mb-8 body4 md:body3 text-center md:mb-20 md:max-w-lg">
          Over the course of two days, Ripple Swell will cover a wide range of
          topics from Ripple customers, team members and industry thought
          leaders to reveal how financial institutions and businesses alike are
          leveraging crypto and blockchain technology. Topics include:
        </p>
      </div>
    </PageGrid>
    <ScrollingLogos
      wrapperClass="pt-8 pb-5"
      arrLTR={sessionsArrLTR}
      addFilter={false}
    />
  </section>
)

export default SessionTopics
